<template src="./mims.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
    name: "mims",
    data() {
      return {
        role: 'licensor',
        
        state : 'verified', // 가입 상태 - 인증
        currency: null,
        payment_method: null,
        default_service_fee_kr: 15,                  // 한국 정산요율
        default_service_fee_other: 15,               // 해외 정산요율
        entity_tax_exemption: false,                // 면세
        roleOption: optionData.role,
        paymentOption : optionData.payment,
        currencyOption: optionData.currency,
        
        fileList: [],
        files: [],              // 파일 데이터
        
        modals: {
          modal1: false
        },

        accept:" .xml",
        extensions:'xml',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        name: 'file',
        uploadAuto: false,
      }
    },
    watch :{
      'payment_method'(data){
        if(this.payment_method == 'kr_banktransfer'){
          this.currency = 'krw'
        }else{
          this.currency = null
        }
      },
    },
    mounted(){
      this.$nextTick(() => {
        this.$refs.upload.drop = true
        this.$forceUpdate();
      })
    },
    methods: {
      goList(){
        this.historyBack();
      },
      all_save(){
        this.closeModal('confirm')
        if(!this.files[0]) {
          this.alert({msg: `파일(xml)을 등록해주세요.`,})
          return false
        }
        const payload = {
          file: this.files[0].file,
        }
        
        
        this.$store.dispatch('albumInfo/mimsImport', payload.file)
            .then(result =>{
              this.alert({
                  msg: '등록되었습니다.',
              })
              this.goList()
            }).catch(error =>{
                const err = error.response.data.code
                switch(err){
                    case 4:
                        this.alert({
                            msg: '해당 앨범정보가 등록되있지 않습니다.',
                        })
                        break;
                    default:
                        this.alert({
                          msg: error.response.data.message,
                        })
                        break;
                }
            })
      },
      send_template(params){
             // 지급방법
      },
      objectCompare(targetObj , subObj2) {
        return targetObj.map(t_obj =>{
          return t_obj.id
        }).filter(t_obj =>{
          return !subObj2.map(s_obj =>{
                  return s_obj.id
                }).includes(t_obj)
        })
      },
      handleRemove(file, fileList){
        this.file = null
      },
      handleChange(file, fileList){
        this.file = file.raw
        this.fileList = []
        this.fileList.push(fileList[fileList.length-1])
      },
      closeOpen(modalNo){
        return new Promise(resolve =>{
          resolve(this.modals[modalNo] = false)
        })
      },


     
    }
}
</script>

<style  lang="scss" scoped>


.el-upload-dragger {
  background: transparent !important;
  background-color: #000 !important;
}
.el-upload {
  width: 100%;
}

</style>